import { Box, FormControl, MenuItem, Select } from "@mui/material";
import FormControlErrorStyles from "assets/style/Component";
import pxToRem from "assets/theme/functions/pxToRem";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Cosntants, { Icons } from "utils/Constants";
import PropTypes from "prop-types";

const filterDropdown = ({
  label,
  name,
  defaultValue,
  value,
  handleChange,
  menu,
  minWidth = 150,
  menuMaxWidth = "none",
}) => (
  <FormControl
    sx={{
      mr: 1.5,
      mt: pxToRem(8),
      ml: 0,
      mb: 0,
      minWidth,
      maxHeight: 400,
      ...FormControlErrorStyles,
    }}
    size="small"
  >
    <MDTypography
      variant="caption"
      mb={0.5}
      sx={{ fontSize: pxToRem(12.5), fontWeight: 600, color: "#344054" }}
    >
      {label}
    </MDTypography>
    <Select
      variant="standard"
      displayEmpty
      labelId="demo-select-small"
      id="demo-select-small"
      name={name}
      defaultValue={defaultValue}
      value={value}
      sx={{
        height: 32,
        color: "black",
        fontWeight: 600,
        backgroundColor: "#fff",
        paddingY: "0.3rem",
        paddingRight: "0.55rem",
        maxHeight: 100,
        cursor: "pointer",
        fontSize: pxToRem(13),
      }}
      MenuProps={{
        anchorOrigin: {
          vertical: 29,
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        PaperProps: {
          style: {
            maxHeight: 200,
            maxWidth: menuMaxWidth,
            opacity: 1,
            transform: "none",
            top: 183,
            left: 442,
          },
        },
      }}
      onChange={handleChange}
      IconComponent={Icons.DROPDOWN}
      renderValue={(selected) => {
        const val = menu.filter(
          (opt) => opt?.[Cosntants.MONGOOSE_ID] === selected || opt === selected
        )[0];
        return (
          <MDBox sx={{ display: "flex", alignItems: "center" }}>
            {val?.color && val?.color !== "" ? (
              <Box
                component="span"
                sx={{
                  backgroundColor: `#${val?.color}`,
                  borderRadius: "50%",
                  width: "10px",
                  height: "10px",
                  mr: 1,
                }}
              />
            ) : null}
            <MDTypography variant="caption" sx={{ textTransform: "capitalize" }}>
              {val?.title || val}
            </MDTypography>
          </MDBox>
        );
      }}
    >
      {menu.map((item) => (
        <MenuItem
          value={item[Cosntants.MONGOOSE_ID] || item}
          sx={{
            textTransform: "capitalize",
            maxHeight: 400,
            fontSize: pxToRem(14),
            fontWeight: 400,
            marginTop: "4px",
            color: "#344054",
          }}
          key={item[Cosntants.MONGOOSE_ID] || item.replace(/\s/g, "")}
        >
          {item?.color && item?.color !== "" && (
            <Box
              component="span"
              sx={{
                backgroundColor: `#${item?.color}`,
                borderRadius: "50%",
                width: "10px",
                height: "10px",
                mr: 1,
              }}
            />
          )}
          <MDTypography
            variant="caption"
            sx={{
              textTransform: "capitalize",
              fontSize: pxToRem(16),
              fontWeight: 400,
              color: "#667085",
              display: "flex",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {item.title || item}
          </MDTypography>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

filterDropdown.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  menu: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  menuMaxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

filterDropdown.defaultProps = {
  label: "",
  name: "",
  defaultValue: "",
  value: "",
  handleChange: () => {},
  menu: [],
  minWidth: 150,
  menuMaxWidth: "none",
};

export default filterDropdown;
